import { Link } from "react-router-dom";

const posts = [
  { slug: "global-infrastructure", tag: "Infrastructure", tagColor: "#34a853", date: "Mar 15, 2025", title: "The Aethernet: own part of the internet, earn from it", excerpt: "How we built the Aethernet — a patent-pending network where people own, power, and benefit from the infrastructure they contribute to." },
  { slug: "why-we-started", tag: "Company", tagColor: "#4285f4", date: "Mar 1, 2025", title: "Why we started Eamico", excerpt: "Deploying code shouldn't be harder than writing it. Here's the story behind Eamico and where we're going." },
  { slug: "deploy-anywhere", tag: "Engineering", tagColor: "#ea4335", date: "Feb 20, 2025", title: "Deploy anywhere, scale everywhere — our technical approach", excerpt: "A deep dive into the architecture powering Eamico's global deployment platform." },
  { slug: "developer-experience", tag: "Product", tagColor: "#ff9a4d", date: "Feb 10, 2025", title: "Developer experience is a feature, not a nice-to-have", excerpt: "Why we obsess over every detail of the developer workflow — and how it shapes our product decisions." },
  { slug: "security-first", tag: "Security", tagColor: "#ffc366", date: "Jan 25, 2025", title: "Security-first: how we protect your code and data", excerpt: "Enterprise-grade security shouldn't cost enterprise prices. Here's how we bake security into every layer." },
];

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="blog-page">
      <div className="bg-[#f8f9fa] border-b border-[#e8eaed]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-8 py-16 sm:py-20 lg:py-24">
          <h1 className="text-[32px] sm:text-[40px] lg:text-[48px] font-normal text-[#202124]" data-testid="blog-title">Blog</h1>
          <p className="mt-4 text-base sm:text-lg text-[#5f6368] max-w-lg">Insights, updates, and stories from the Eamico team.</p>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        {/* Featured */}
        <Link to="#" className="group block p-8 sm:p-10 rounded-xl border border-[#e8eaed] hover:border-[#dadce0] hover:shadow-md transition-all mb-10" data-testid="blog-featured">
          <span className="inline-block text-[11px] font-bold tracking-wide uppercase mb-3" style={{ color: posts[0].tagColor }}>{posts[0].tag}</span>
          <h2 className="text-[24px] sm:text-[30px] font-normal text-[#202124] group-hover:text-[#ff9a4d] transition-colors leading-snug">{posts[0].title}</h2>
          <p className="mt-3 text-[15px] text-[#5f6368] max-w-2xl leading-relaxed">{posts[0].excerpt}</p>
          <p className="mt-4 text-[13px] text-[#9aa0a6]">{posts[0].date}</p>
        </Link>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
          {posts.slice(1).map((post, i) => (
            <Link key={post.slug} to="#" className="group block p-6 rounded-xl border border-[#e8eaed] hover:border-[#dadce0] hover:shadow-sm transition-all" data-testid={`blog-post-${i}`}>
              <span className="inline-block text-[11px] font-bold tracking-wide uppercase mb-3" style={{ color: post.tagColor }}>{post.tag}</span>
              <h3 className="text-[16px] font-medium text-[#202124] group-hover:text-[#ff9a4d] transition-colors leading-snug mb-2">{post.title}</h3>
              <p className="text-[13px] text-[#5f6368] leading-relaxed mb-3">{post.excerpt}</p>
              <p className="text-[12px] text-[#9aa0a6]">{post.date}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
